import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _16a337d8 = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _88dda886 = () => interopDefault(import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _22c1ae60 = () => interopDefault(import('../pages/afrekenen.vue' /* webpackChunkName: "pages/afrekenen" */))
const _2e274ee4 = () => interopDefault(import('../pages/betaling/index.vue' /* webpackChunkName: "pages/betaling/index" */))
const _26031a95 = () => interopDefault(import('../pages/brochure-aanvragen.vue' /* webpackChunkName: "pages/brochure-aanvragen" */))
const _003a828e = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _7e2c0454 = () => interopDefault(import('../pages/inloggen.vue' /* webpackChunkName: "pages/inloggen" */))
const _6a0c0268 = () => interopDefault(import('../pages/kennisbank/index.vue' /* webpackChunkName: "pages/kennisbank/index" */))
const _7d85f228 = () => interopDefault(import('../pages/nieuws.vue' /* webpackChunkName: "pages/nieuws" */))
const _5cebac6f = () => interopDefault(import('../pages/nieuws/index.vue' /* webpackChunkName: "pages/nieuws/index" */))
const _7ab46606 = () => interopDefault(import('../pages/nieuws/_category/index.vue' /* webpackChunkName: "pages/nieuws/_category/index" */))
const _4830f640 = () => interopDefault(import('../pages/nieuws/_category/_item/index.vue' /* webpackChunkName: "pages/nieuws/_category/_item/index" */))
const _3e43a68e = () => interopDefault(import('../pages/over.vue' /* webpackChunkName: "pages/over" */))
const _2103e334 = () => interopDefault(import('../pages/over/_slug.vue' /* webpackChunkName: "pages/over/_slug" */))
const _5a572840 = () => interopDefault(import('../pages/over-ons.vue' /* webpackChunkName: "pages/over-ons" */))
const _09a96986 = () => interopDefault(import('../pages/producten/index.vue' /* webpackChunkName: "pages/producten/index" */))
const _31b97d7d = () => interopDefault(import('../pages/registreren.vue' /* webpackChunkName: "pages/registreren" */))
const _6859abdc = () => interopDefault(import('../pages/school/index.vue' /* webpackChunkName: "pages/school/index" */))
const _a6802c4a = () => interopDefault(import('../pages/shop.vue' /* webpackChunkName: "pages/shop" */))
const _7ba33fc4 = () => interopDefault(import('../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _a28a1c28 = () => interopDefault(import('../pages/shop/_category/index.vue' /* webpackChunkName: "pages/shop/_category/index" */))
const _038c90f4 = () => interopDefault(import('../pages/shop/_category/_product.vue' /* webpackChunkName: "pages/shop/_category/_product" */))
const _15dfcdc7 = () => interopDefault(import('../pages/speciaal-voor-scholen.vue' /* webpackChunkName: "pages/speciaal-voor-scholen" */))
const _53ab278c = () => interopDefault(import('../pages/sso.vue' /* webpackChunkName: "pages/sso" */))
const _15368cda = () => interopDefault(import('../pages/wachtwoord-vergeten/index.vue' /* webpackChunkName: "pages/wachtwoord-vergeten/index" */))
const _4891cbbb = () => interopDefault(import('../pages/winkelwagen.vue' /* webpackChunkName: "pages/winkelwagen" */))
const _403b3a39 = () => interopDefault(import('../pages/zoekresultaten.vue' /* webpackChunkName: "pages/zoekresultaten" */))
const _edf37034 = () => interopDefault(import('../pages/admin/abonnementen/index.vue' /* webpackChunkName: "pages/admin/abonnementen/index" */))
const _679c25cc = () => interopDefault(import('../pages/admin/facturen/index.vue' /* webpackChunkName: "pages/admin/facturen/index" */))
const _6d3a7824 = () => interopDefault(import('../pages/admin/offertes/index.vue' /* webpackChunkName: "pages/admin/offertes/index" */))
const _7a2436f0 = () => interopDefault(import('../pages/admin/pakketten.vue' /* webpackChunkName: "pages/admin/pakketten" */))
const _2c866233 = () => interopDefault(import('../pages/admin/relaties/index.vue' /* webpackChunkName: "pages/admin/relaties/index" */))
const _707f39ea = () => interopDefault(import('../pages/betaling/afgerond.vue' /* webpackChunkName: "pages/betaling/afgerond" */))
const _c4cfc3a8 = () => interopDefault(import('../pages/demo/rekenblobs.vue' /* webpackChunkName: "pages/demo/rekenblobs" */))
const _55d79f97 = () => interopDefault(import('../pages/demo/taalblobs.vue' /* webpackChunkName: "pages/demo/taalblobs" */))
const _cdbbe066 = () => interopDefault(import('../pages/info/algemene-voorwaarden.vue' /* webpackChunkName: "pages/info/algemene-voorwaarden" */))
const _3494db24 = () => interopDefault(import('../pages/info/privacy-statement.vue' /* webpackChunkName: "pages/info/privacy-statement" */))
const _141b0a7c = () => interopDefault(import('../pages/school/leerling.vue' /* webpackChunkName: "pages/school/leerling" */))
const _24197ccc = () => interopDefault(import('../pages/admin/facturen/aanmaken.vue' /* webpackChunkName: "pages/admin/facturen/aanmaken" */))
const _046b0a46 = () => interopDefault(import('../pages/admin/offertes/aanmaken.vue' /* webpackChunkName: "pages/admin/offertes/aanmaken" */))
const _1b4bec3e = () => interopDefault(import('../pages/admin/relaties/aanmaken.vue' /* webpackChunkName: "pages/admin/relaties/aanmaken" */))
const _3d9de864 = () => interopDefault(import('../pages/admin/abonnementen/_id.vue' /* webpackChunkName: "pages/admin/abonnementen/_id" */))
const _ade62c54 = () => interopDefault(import('../pages/admin/offertes/_id.vue' /* webpackChunkName: "pages/admin/offertes/_id" */))
const _607ba08e = () => interopDefault(import('../pages/admin/organisaties/_id.vue' /* webpackChunkName: "pages/admin/organisaties/_id" */))
const _c390ea1e = () => interopDefault(import('../pages/admin/particulieren/_id.vue' /* webpackChunkName: "pages/admin/particulieren/_id" */))
const _e7038698 = () => interopDefault(import('../pages/admin/scholen/_id.vue' /* webpackChunkName: "pages/admin/scholen/_id" */))
const _fa7cfa8c = () => interopDefault(import('../pages/admin/studenten/_id.vue' /* webpackChunkName: "pages/admin/studenten/_id" */))
const _20041809 = () => interopDefault(import('../pages/wachtwoord-vergeten/reset/_token.vue' /* webpackChunkName: "pages/wachtwoord-vergeten/reset/_token" */))
const _02f83d74 = () => interopDefault(import('../pages/contact/_slug.vue' /* webpackChunkName: "pages/contact/_slug" */))
const _68556120 = () => interopDefault(import('../pages/kennisbank/_slug.vue' /* webpackChunkName: "pages/kennisbank/_slug" */))
const _7d530ac3 = () => interopDefault(import('../pages/kennisbank/_slug/_item.vue' /* webpackChunkName: "pages/kennisbank/_slug/_item" */))
const _07f2c83e = () => interopDefault(import('../pages/producten/_slug.vue' /* webpackChunkName: "pages/producten/_slug" */))
const _3b3a732a = () => interopDefault(import('../pages/verleng/_id.vue' /* webpackChunkName: "pages/verleng/_id" */))
const _58f36335 = () => interopDefault(import('../pages/wachtwoord-instellen/_token.vue' /* webpackChunkName: "pages/wachtwoord-instellen/_token" */))
const _3b2044bd = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5d145cd6 = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _16a337d8,
    name: "account"
  }, {
    path: "/admin",
    component: _88dda886,
    name: "admin"
  }, {
    path: "/afrekenen",
    component: _22c1ae60,
    name: "afrekenen"
  }, {
    path: "/betaling",
    component: _2e274ee4,
    name: "betaling"
  }, {
    path: "/brochure-aanvragen",
    component: _26031a95,
    name: "brochure-aanvragen"
  }, {
    path: "/contact",
    component: _003a828e,
    name: "contact"
  }, {
    path: "/inloggen",
    component: _7e2c0454,
    name: "inloggen"
  }, {
    path: "/kennisbank",
    component: _6a0c0268,
    name: "kennisbank"
  }, {
    path: "/nieuws",
    component: _7d85f228,
    children: [{
      path: "",
      component: _5cebac6f,
      name: "nieuws"
    }, {
      path: ":category",
      component: _7ab46606,
      name: "nieuws-category"
    }, {
      path: ":category/:item",
      component: _4830f640,
      name: "nieuws-category-item"
    }]
  }, {
    path: "/over",
    component: _3e43a68e,
    name: "over",
    children: [{
      path: ":slug?",
      component: _2103e334,
      name: "over-slug"
    }]
  }, {
    path: "/over-ons",
    component: _5a572840,
    name: "over-ons"
  }, {
    path: "/producten",
    component: _09a96986,
    name: "producten"
  }, {
    path: "/registreren",
    component: _31b97d7d,
    name: "registreren"
  }, {
    path: "/school",
    component: _6859abdc,
    name: "school"
  }, {
    path: "/shop",
    component: _a6802c4a,
    children: [{
      path: "",
      component: _7ba33fc4,
      name: "shop"
    }, {
      path: ":category",
      component: _a28a1c28,
      name: "shop-category"
    }, {
      path: ":category/:product",
      component: _038c90f4,
      name: "shop-category-product"
    }]
  }, {
    path: "/speciaal-voor-scholen",
    component: _15dfcdc7,
    name: "speciaal-voor-scholen"
  }, {
    path: "/sso",
    component: _53ab278c,
    name: "sso"
  }, {
    path: "/wachtwoord-vergeten",
    component: _15368cda,
    name: "wachtwoord-vergeten"
  }, {
    path: "/winkelwagen",
    component: _4891cbbb,
    name: "winkelwagen"
  }, {
    path: "/zoekresultaten",
    component: _403b3a39,
    name: "zoekresultaten"
  }, {
    path: "/admin/abonnementen",
    component: _edf37034,
    name: "admin-abonnementen"
  }, {
    path: "/admin/facturen",
    component: _679c25cc,
    name: "admin-facturen"
  }, {
    path: "/admin/offertes",
    component: _6d3a7824,
    name: "admin-offertes"
  }, {
    path: "/admin/pakketten",
    component: _7a2436f0,
    name: "admin-pakketten"
  }, {
    path: "/admin/relaties",
    component: _2c866233,
    name: "admin-relaties"
  }, {
    path: "/betaling/afgerond",
    component: _707f39ea,
    name: "betaling-afgerond"
  }, {
    path: "/demo/rekenblobs",
    component: _c4cfc3a8,
    name: "demo-rekenblobs"
  }, {
    path: "/demo/taalblobs",
    component: _55d79f97,
    name: "demo-taalblobs"
  }, {
    path: "/info/algemene-voorwaarden",
    component: _cdbbe066,
    name: "info-algemene-voorwaarden"
  }, {
    path: "/info/privacy-statement",
    component: _3494db24,
    name: "info-privacy-statement"
  }, {
    path: "/school/leerling",
    component: _141b0a7c,
    name: "school-leerling"
  }, {
    path: "/admin/facturen/aanmaken",
    component: _24197ccc,
    name: "admin-facturen-aanmaken"
  }, {
    path: "/admin/offertes/aanmaken",
    component: _046b0a46,
    name: "admin-offertes-aanmaken"
  }, {
    path: "/admin/relaties/aanmaken",
    component: _1b4bec3e,
    name: "admin-relaties-aanmaken"
  }, {
    path: "/admin/abonnementen/:id",
    component: _3d9de864,
    name: "admin-abonnementen-id"
  }, {
    path: "/admin/offertes/:id",
    component: _ade62c54,
    name: "admin-offertes-id"
  }, {
    path: "/admin/organisaties/:id?",
    component: _607ba08e,
    name: "admin-organisaties-id"
  }, {
    path: "/admin/particulieren/:id?",
    component: _c390ea1e,
    name: "admin-particulieren-id"
  }, {
    path: "/admin/scholen/:id?",
    component: _e7038698,
    name: "admin-scholen-id"
  }, {
    path: "/admin/studenten/:id?",
    component: _fa7cfa8c,
    name: "admin-studenten-id"
  }, {
    path: "/wachtwoord-vergeten/reset/:token",
    component: _20041809,
    name: "wachtwoord-vergeten-reset-token"
  }, {
    path: "/contact/:slug",
    component: _02f83d74,
    name: "contact-slug"
  }, {
    path: "/kennisbank/:slug",
    component: _68556120,
    name: "kennisbank-slug",
    children: [{
      path: ":item?",
      component: _7d530ac3,
      name: "kennisbank-slug-item"
    }]
  }, {
    path: "/producten/:slug",
    component: _07f2c83e,
    name: "producten-slug"
  }, {
    path: "/verleng/:id?",
    component: _3b3a732a,
    name: "verleng-id"
  }, {
    path: "/wachtwoord-instellen/:token?",
    component: _58f36335,
    name: "wachtwoord-instellen-token"
  }, {
    path: "/",
    component: _3b2044bd,
    name: "index"
  }, {
    path: "/*",
    component: _5d145cd6,
    name: "*"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decodeURIComponent(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
